import Vue from "vue";
export default {
  GET_PODCAST(state, payload) {
    state.getPodcast = payload;
  },

  GET_ALL_PODCAST(state, payload) {
    state.getAllPodcast = payload;
  },

  SELECTED_PODCAST(state, payload) {
    state.selectedPodcast = payload;
  },

  GET_CATEGORY(state, payload) {
    state.getCategory = payload;
  },

  GET_ALL_CATEGORY(state, payload) {
    state.getAllCategory = payload;
  },

  SELECTED_CATEGORY(state, payload) {
    state.selectedCategory = payload;
  },

  GET_EPISODE(state, payload) {
    state.getEpisode = payload;
  },

  GET_ALL_EPISODE(state, payload) {
    state.getAllEpisode = payload;
  },

  SELECTED_EPISODE(state, payload) {
    state.selectedEpisode = payload;
  },

  GET_ALL_HISTORY(state, payload) {
    state.getAllHistory = payload;
  },

  // GET_ALL_FORM(state, payload) {
  //   state.getAllForm = payload;
  // },
};
